import styled from 'styled-components';
import media from 'src/styles/Media.styled';
export const SubTitleComponent = styled.span`
    font-family: 'AvenirNextWorld Demi';
    font-size: 24px;
    align-content: 'left';
    color: #140f4b;
`;

export const ConsignmentProductWrapper = styled.div`
    padding-bottom: 60px;
`;
export const StyledDiv = styled.div`
    width: ${({ width }) => width};
    margin: ${({ margin }) => margin};
    

    @media only screen and (min-width: 1023px) and (max-width: 1025px) {
        margin: ${({ margin }) =>
            margin === '15px 0px 0px -258px'
                ? '15px 0px 0px -208px'
                : margin === '35px 0px 0px -258px' && '35px 0px 0px -208px'};
    }
    @media only screen and (min-width: 768px) and (max-width: 770px) {
        margin: ${({ margin }) =>
            margin === '15px 0px 0px -258px'
                ? '15px 0px 0px -168px'
                : margin === '35px 0px 0px -258px' && '35px 0px 0px -168px'};
    }
    @media only screen and (min-width: 820px) and (max-width: 823px) {
        margin: ${({ margin }) =>
            margin === '15px 0px 0px -258px'
                ? '15px 0px 0px -180px'
                : margin === '35px 0px 0px -258px' && '35px 0px 0px -180px'};
    }
`;
export const ConsignmentBillingWrapper = styled.div`
    .title-conteiner-wrapper {
        display: flex;
        alignitems: center;
        marginbottom: 24px;
        margintop: 24px;
        width: ${(props) => (props.isPriceOverride ? '100%' : '50%')};
        padding: ${({ isCondensedView }) =>
            isCondensedView ? '5px 0' : '15px 0'};
        ${media.mobileDevice`
            width: 100%;
            padding: ${(props) =>
                props.isPriceOverride ? '5px 0 15px 0' : ''};
        `}
    }
`;

export const AddButton = styled.div`
    font-family: 'AvenirNextWorld Demi';
    color: #1010eb;
    text-align: center;
    font-size: 13px;
    width: 150px;
    height: 34px;
    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
    background: #ffffff 0% 0% no-repeat padding-box;
    box-shadow: 0px 0px 2px #00000029;
    border-radius: 17px;
    opacity: 1;
    padding-top: 6px;
    ${media.mobileDevice`
        width: 150px;
        height: 34px;
        background: #FFFFFF 0% 0% no-repeat padding-box;
        box-shadow: 0px 0px 2px #00000029;
        border-radius: 17px;
        opacity: 1;
        position:;
        top: 300px;
        right: 15px;
    `}
`;

export const IconPlaceHolder = styled.div`
    margin: ${({ margin }) => margin};
    /* border: 1px solid #140f4b; */
    opacity: 1;
    width: ${({ width }) => width};
    height: ${({ height }) => height};
    //to make quick order header align
    /* margin-right: 17px;
     */
    margin-right: 10px;
    ${media.mobileDevice`
        margin-right : ${({ marginRight }) =>
            marginRight ? marginRight : '0px'};
    `}
`;

export const Icon = styled.div`
    background: url(${(props) => props.deskPath});
    height: 2.7rem;
    width: 2.7rem;
    cursor: pointer;
    background-repeat: no-repeat;
    position: relative;
    margin-right: ${(props) =>
        props.marginRightDesktop ? props.marginRightDesktop : '0px'};
    ${media.mobileDevice`
        background: url(${(props) => props.mobilePath});
        background-repeat: no-repeat;
        margin-right: ${(props) =>
            props.marginRightMobile ? props.marginRightMobile : '0px'};
        bottom: ${(props) => props.bottom};
    `}
`;
